import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALPERSONNEL_LOAD_BY_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID,
    ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID,

    ACTION_TRIALPERSONNEL_SAVE,

    ACTION_TRIALPERSONNEL_CREATE,

    ACTION_TRIALPERSONNEL_VALIDATE,

    ITrialPersonnelLoadByIdAction,
    ITrialPersonnelsLoadByPersonnelIdAction,
    ITrialPersonnelsLoadByTrialIdAction,
    ITrialPersonnelsLoadByTrialInstitutionIdAction,
    ITrialPersonnelsLoadByGroupIdAction,
    ITrialPersonnelLoadFailureAction,
    ITrialPersonnelLoadSuccessAction,

    ITrialPersonnelSaveAction,
    ITrialPersonnelSaveSuccessAction,
    ITrialPersonnelSaveFailureAction,

    ITrialPersonnelCreateAction,
    ITrialPersonnelCreateSuccessAction,
    ITrialPersonnelCreateFailureAction,

    ITrialPersonnelValidateAction,
    ITrialPersonnelValidateSuccessAction,
    ITrialPersonnelValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID,
    ITrialPersonnelsLoadByTrialGroupIdAction,
    ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID,
    ITrialPersonnelsLoadByInstitutionIdAction,

} from "../actions/trialPersonnel";
import { trialPersonnelsApi } from "../services/trialPersonnels";


export const
    getTrialPersonnelsByIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNEL_LOAD_BY_ID)
            .mergeMap((action: ITrialPersonnelLoadByIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialPersonnel, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPersonnelsByPersonnelIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID)
            .mergeMap((action: ITrialPersonnelsLoadByPersonnelIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelsByPersonnelId(action.personnelId)
                    .map(response =>
                        LoadSuccess(response.trialPersonnels, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPersonnelsByTrialIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID)
            .mergeMap((action: ITrialPersonnelsLoadByTrialIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelsByTrialId(action.trialId, action.groupLevelTypeId)
                    .map(response =>
                        LoadSuccess(response.trialPersonnels, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPersonnelsByInstitutionIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID)
            .mergeMap((action: ITrialPersonnelsLoadByInstitutionIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelsByInstitutionId(action.institutionId, action.groupLevelTypeId)
                    .map(response =>
                        LoadSuccess(response.trialPersonnels, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPersonnelsByTrialInstitutionIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID)
            .mergeMap((action: ITrialPersonnelsLoadByTrialInstitutionIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelsByTrialInstitutionId(action.trialInstitutionId, action.groupLevelTypeId)
                    .map(response =>
                        LoadSuccess(response.trialPersonnels, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPersonnelsByTrialGroupIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID)
            .mergeMap((action: ITrialPersonnelsLoadByTrialGroupIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelsByTrialGroupId(action.trialGroupId, action.groupLevelTypeId)
                    .map(response =>
                        LoadSuccess(response.trialPersonnels, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialPersonnelsByGroupIdEpic = (action$): Observable<ITrialPersonnelLoadSuccessAction | ITrialPersonnelLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID)
            .mergeMap((action: ITrialPersonnelsLoadByGroupIdAction) => {
                return trialPersonnelsApi
                    .getTrialPersonnelsByGroupId(action.groupId, action.groupLevelTypeId)
                    .map(response =>
                        LoadSuccess(response.trialPersonnels, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialPersonnelEpic = (action$): Observable<ITrialPersonnelSaveSuccessAction | ITrialPersonnelSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNEL_SAVE)
            .mergeMap((action: ITrialPersonnelSaveAction) => {
                return trialPersonnelsApi
                    .setTrialPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialPersonnelEpic = (action$): Observable<ITrialPersonnelCreateSuccessAction | ITrialPersonnelCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNEL_CREATE)
            .mergeMap((action: ITrialPersonnelCreateAction) => {
                return trialPersonnelsApi
                    .createTrialPersonnel(action.trialId, action.institutionId, action.groupId)
                    .map(response =>
                        CreateSuccess(response.trialPersonnel, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialPersonnelEpic = (action$): Observable<ITrialPersonnelValidateSuccessAction | ITrialPersonnelValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALPERSONNEL_VALIDATE)
            .mergeMap((action: ITrialPersonnelValidateAction) => {
                return trialPersonnelsApi
                    .validateTrialPersonnel(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialPersonnel, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



